"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedActionBar = void 0;
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var CsButton_1 = __importDefault(require("../Buttons/CsButton"));
var react_i18next_1 = require("react-i18next");
var FixedActionBar_styles_1 = require("./FixedActionBar.styles");
var getLeftSpaceColumns = function (nActions, large, conditions, fixedButtonSizes) {
    if (conditions)
        nActions -= conditions.filter(function (c) { return !c; }).length;
    var baseVal = fixedButtonSizes
        ? 12 - fixedButtonSizes.reduce(function (prev, curr) { return prev + curr; }, 0)
        : 12 - (large ? 4 : 2) * nActions;
    return Math.max(2, Math.min(baseVal, 10));
};
exports.FixedActionBar = function (_a) {
    var largeButtons = _a.largeButtons, actions = _a.actions, conditions = _a.conditions, buttonProps = _a.buttonProps, labels = _a.labels, fixedButtonSizes = _a.fixedButtonSizes, icons = _a.icons, disabled = _a.disabled;
    var t = react_i18next_1.useTranslation('common').t;
    var usedButtonProps = buttonProps !== null && buttonProps !== void 0 ? buttonProps : actions.map(function () { return undefined; });
    return (react_1.default.createElement(Paper_1.default, { elevation: 4, style: FixedActionBar_styles_1.fixedActionBar },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 3 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: getLeftSpaceColumns(actions.length, largeButtons, conditions, fixedButtonSizes) }, ' '),
            icons.map(function (icon, i) {
                return (!conditions || conditions[i]) && (react_1.default.createElement(Grid_1.default, { key: i, item: true, xs: fixedButtonSizes ? fixedButtonSizes[i] : largeButtons ? 4 : 2 },
                    react_1.default.createElement(CsButton_1.default, __assign({}, usedButtonProps[i], { onClick: actions[i], disabled: disabled && disabled[i], fullwidth: true, label: t(labels[i]) }), react_1.default.createElement(icons[i]))));
            }))));
};
exports.default = exports.FixedActionBar;
//# sourceMappingURL=FixedActionBar.js.map